export default "__VITE_ASSET__DAR27v7v__"